import { render, staticRenderFns } from "./HelpCentre.vue?vue&type=template&id=10ce3f5d&scoped=true"
import script from "./HelpCentre.vue?vue&type=script&lang=js"
export * from "./HelpCentre.vue?vue&type=script&lang=js"
import style0 from "./HelpCentre.vue?vue&type=style&index=0&id=10ce3f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce3f5d",
  null
  
)

export default component.exports